import React, { FC } from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { 
  ImgBox,
  Typography700,
 } from 'views/rebranded-module/common/components';
import  StyledBox  from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/UltimateTestRideSection/UltimateTestRideSection.styles';
import ScrollTo from 'lib/utils/ScrollTo';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const UltimateTestRideSection: FC<any> = () => {
const getSizedImage = useAdabtiveMultiSizeImage();
const content = useContent('MembershipLandingPage');
 const handleScrollToPlansComparison = () => {
  ScrollTo('plans-comparison-section', -60);
};
  return (
    <StyledBox>
      <Box className="UTRSTextContainer">
        <Typography700 component="p" variant="h2">
          {content.ultimateTestRideSectionTitle}
        </Typography700>
        <Typography component="p" variant="body1"  color="text.secondary">
          {content.ultimateTestRideSectionDescription}
        </Typography>
        <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleScrollToPlansComparison}
            >
          {content.joinClubBtn}
        </Button>
      </Box>
        <Box className="UTRImageContainer">
          <ImgBox
            image={{
                src: getSizedImage(content.ultimateTestRideSectionImage.sizes),
                alt: content.ultimateTestRideSectionImage.alt,
              }}
            width="100%"
            height="100%"
          />                                                              
        </Box>
     
    </StyledBox>
  );
};

export { UltimateTestRideSection };
